import React, {Suspense, useEffect} from "react";
import "./shopping-cart.styles.scss";
import Row from "react-bootstrap/Row";
import {shallowEqual, useSelector} from "react-redux";
import Skeleton from 'react-loading-skeleton';
import {getPageDataByApiUrl} from "../../../js/api/get-pages.data";
import {ENDPOINTS} from "../../../js/api/_config";
import ShoppingCardHeaderComponent from "./ShoppingCartHeaderComponent";
import ShoppingCartWrapperComponent from "./ShoppingCartWrapperComponent";

function ShoppingCart() {
    const [pageContent, setPageContent] = React.useState(null);

    const cartItems = useSelector(({cart}) => cart.cart, shallowEqual);

    useEffect(() => {
        async function getDataFromURL() {
            let response = await getPageDataByApiUrl(ENDPOINTS.USER_CART_ACCOUNT.SHOPPING_CART_URL);
            console.log(response);
            return response;
        }

        getDataFromURL().then(response => {
            setPageContent(response)
        });

    }, []);

    // const ShoppingCartHeaderComponent = React.lazy(() => import('./ShoppingCartHeaderComponent'));
    // const ShoppingCartWrapperComponent = React.lazy(() => import('./ShoppingCartWrapperComponent'));

    // if (!pageContent) {
    //     return <CartLoader/>;
    // }

    return (
        <Row className="shopping-cart module-bottom-spacer trinity-container">
            {/* <Suspense fallback={<Skeleton/>}> */}
                <ShoppingCardHeaderComponent MainContent={pageContent?.MainContent}/>
            {/* </Suspense> */}
            {/* <Suspense fallback={<Skeleton/>}> */}
                <ShoppingCartWrapperComponent cartItems={cartItems} MainContent={pageContent?.MainContent}/>
            {/* </Suspense> */}
        </Row>
    )
}

export default ShoppingCart;
